import { SearchModel } from "src/common/components";
import { DocumentComponentName } from "src/common/enums/documentComponentName";

export class DocumentPagesRequestModel {
  documentId: number;
  pages: number[];
}

export class DocumentPageModel {
  page: number;
  content: string;
}

export class DocumentPagesModel {
  pages: DocumentPageModel[];
}


export class DocumentFileModel {
  id?: number;
  requestId: number;
  documentId: number;
  name: string;
}

export class DocumentFileSaveModel {
  id?: number;
  requestId: number;
  documentId: number;
  name: string;
  content: string;
  documentComponentName:DocumentComponentName
}

export class DocumentFileDownloadModel {
  id: number;
  name: string;
  content: string;
}


export class DocumentFileSearchModel {
  search: SearchModel;
  documentComponentName: DocumentComponentName;
}
